/* eslint-disable @typescript-eslint/return-await */
import { routes } from '@linqpal/models'

export const customerSearchFn = async (input) => {
  return await routes.supplier.user({
    search: input,
    limit: 10,
  })
}
